import { createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelDynamic as _vModelDynamic, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Fragment as _Fragment, renderSlot as _renderSlot, resolveDirective as _resolveDirective, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "input" }
const _hoisted_2 = ["data-value"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled", "type", "step", "placeholder", "pattern", "spellcheck", "maxlength", "minlength", "required", "readonly", "min", "max"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "tooltip"
}
const _hoisted_8 = ["data-tooltip"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 3,
  ref: "right",
  class: "custom right"
}
const _hoisted_11 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Footnote = _resolveComponent("Footnote")
  const _component_SymbolCounter = _resolveComponent("SymbolCounter")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["input-inner", {
           left: !!$options.c_icon || $props.type ==='url',
           icon: !!$options.c_icon || !!$props.button,
           corner: $props.type === 'url',
           labeled: $props.type === 'url'
         }]),
      "data-value": $options.c_value
    }, [
      _createCommentVNode(" LEFT ABEL "),
      ($props.type==='url')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            ref: "label",
            disabled: $props.disabled,
            class: _normalizeClass([{invalid: !$data.valid}, "left label url"])
          }, "https://", 10 /* CLASS, PROPS */, _hoisted_3))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" LEFT ICON "),
      (!!$options.c_icon)
        ? (_openBlock(), _createElementBlock("i", {
            key: 1,
            class: "icon",
            disabled: $props.disabled
          }, [
            _createVNode(_component_Icon, {
              icon: $options.c_icon,
              stroke: $props.icon_color,
              error: !$data.valid
            }, null, 8 /* PROPS */, ["icon", "stroke", "error"])
          ], 8 /* PROPS */, _hoisted_4))
        : _createCommentVNode("v-if", true),
      _withDirectives(_createElementVNode("input", {
        ref: "input",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($options.c_value) = $event)),
        disabled: $props.disabled,
        class: _normalizeClass({invalid: !$data.valid, valid: $data.valid}),
        type: ['text', 'email', 'url', 'identifier', 'command'].includes($props.type) ? 'text' : $props.type,
        step: $props.step,
        placeholder: $props.placeholder,
        pattern: $options.pattern,
        spellcheck: $options.c_spellcheck,
        maxlength: $options.c_maxlength,
        minlength: $props.minlength,
        required: $props.required,
        readonly: $props.readonly,
        min: $props.min,
        max: $props.max,
        onBlur: _cache[1] || (_cache[1] = $event => (_ctx.$emit('blur', this)))
      }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_5), [
        [_vModelDynamic, $options.c_value]
      ]),
      _createCommentVNode(" RIGHT CONTROLS "),
      ($props.tooltip || $props.button || $props.rightIcon)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            ref: "right",
            disabled: $props.disabled,
            class: "right"
          }, [
            _createCommentVNode(" TOOLTIP "),
            ($props.tooltip)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", {
                    class: "icon",
                    "data-tooltip": $props.tooltip,
                    "data-inverted": ""
                  }, [
                    _createVNode(_component_Icon, {
                      icon: "help-circle",
                      stroke: "var(--gray-400)",
                      width: $props.iconWidth,
                      height: $props.iconHeight
                    }, null, 8 /* PROPS */, ["width", "height"])
                  ], 8 /* PROPS */, _hoisted_8)
                ]))
              : ($props.rightIcon)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createCommentVNode(" ICON "),
                    _createElementVNode("div", {
                      class: "icon pointer",
                      onClick: _cache[2] || (_cache[2] = $event => (_ctx.$emit('right-icon')))
                    }, [
                      _createVNode(_component_Icon, {
                        icon: $props.rightIcon,
                        stroke: $props.rightIconColor,
                        width: $props.iconWidth,
                        height: $props.iconHeight
                      }, null, 8 /* PROPS */, ["icon", "stroke", "width", "height"])
                    ])
                  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                : ($props.button)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createCommentVNode(" BUTTON  "),
                      _createElementVNode("div", {
                        class: "button pointer",
                        disabled: $props.buttonDisabled,
                        onClick: _cache[3] || (_cache[3] = $event => (_ctx.$emit('button')))
                      }, [
                        _createVNode(_component_Icon, {
                          icon: $props.button,
                          stroke: $props.buttonColor,
                          width: $props.iconWidth,
                          height: $props.iconHeight
                        }, null, 8 /* PROPS */, ["icon", "stroke", "width", "height"])
                      ], 8 /* PROPS */, _hoisted_9)
                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
          ], 8 /* PROPS */, _hoisted_6))
        : (_ctx.$slots.custom_icon)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _renderSlot(_ctx.$slots, "custom_icon", { disabled: $props.disabled }, undefined, true)
            ], 512 /* NEED_PATCH */))
          : _createCommentVNode("v-if", true)
    ], 10 /* CLASS, PROPS */, _hoisted_2)), [
      [_directive_loading, $props.loading]
    ]),
    ($props.footer)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "footer",
          disabled: $props.disabled
        }, [
          ($options.has_validation || $props.description.length > 0)
            ? (_openBlock(), _createBlock(_component_Footnote, {
                key: 0,
                type: $data.valid ? 'default' : 'error'
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($data.valid ? $props.description : $options.error_text), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["type"]))
            : _createCommentVNode("v-if", true),
          ($props.maxlength > 0)
            ? (_openBlock(), _createBlock(_component_SymbolCounter, {
                key: 1,
                current: _ctx.value?.length || 0,
                maxlength: $props.maxlength
              }, null, 8 /* PROPS */, ["current", "maxlength"]))
            : _createCommentVNode("v-if", true)
        ], 8 /* PROPS */, _hoisted_11))
      : _createCommentVNode("v-if", true)
  ]))
}